export function initZoom(scope) {
    const scopePrefix = typeof scope === 'undefined' ? '' : scope + ' ';
    const zoomElement = document.querySelector(scopePrefix + '.zoom');

    if (zoomElement === null) {
        return;
    }

    zoomElement.addEventListener('mousemove', zoom);
}

function zoom(e) {
    if (window.innerWidth <= 768 || !e.offsetX || !e.offsetY) {
        return;
    }
    const zoomer = e.currentTarget;
    let offsetX = 0;
    let offsetY = 0;
    e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
    e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);
    const x = (offsetX / zoomer.offsetWidth) * 100;
    const y = (offsetY / zoomer.offsetHeight) * 100;
    zoomer.style.backgroundPosition = x + '% ' + y + '%';
}
